import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import TopBar from "./TopBar";

const MainLayout = ({ children }) => {
  return (
    <Box sx={{ minHeight: "100%", backgroundColor: "background.default" }}>
      <TopBar />
      <Box sx={{ pt: 9 }}>
        <Box sx={{ display: "flex", minHeight: "100%" }}>
          <Box sx={{ flexGrow: 1 }}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node,
};

export default MainLayout;
